import { render, staticRenderFns } from "./packageList.vue?vue&type=template&id=501f4b24"
import script from "./packageList.vue?vue&type=script&lang=js"
export * from "./packageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports